<template>
  <RevTooltip class="leading-none">
    <template #trigger="{ show, hide }">
      <IconInfo
        :aria-label="i18n(translations.label)"
        :size
        @focusin="show"
        @focusout="hide"
        @mouseleave="hide"
        @mouseover="show"
      />
    </template>
    {{ i18n(props.tooltipTranslation) }}
  </RevTooltip>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

import translations from './OutletPriceTooltip.translations'

const props = withDefaults(
  defineProps<{
    size?: '16' | '20'
    tooltipTranslation: { id: string; defaultMessage: string }
  }>(),
  { size: '16' },
)

const i18n = useI18n()
</script>
